export default interface JsonApiResponse<T> {
  results: T[];
  meta: Meta;
  links: Links;
}

export interface Meta {
  pagination: Pagination;
}

export interface Pagination {
  page: number;
  pages: number;
  count: number;
}

export interface Links {
  first: string;
  last: string;
  next: string;
  prev: null;
}

export function toSinglePageResponse<T>(results: T[]): JsonApiResponse<T> {
  return {
    results,
    meta: { pagination: { page: 1, pages: 1, count: results.length } },
    links: { first: '', last: '', next: '', prev: null },
  };
}
